import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidFileCheckAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.2 17.2c1-1 2.6-1 3.5 0l.2.2 2-2V10h-5c-1.7 0-3-1.3-3-3V2H7C5.3 2 4 3.3 4 5v14c0 1.7 1.3 3 3 3h8.5l-1.2-1.2c-1-1-1-2.6-.1-3.6ZM9 8h1c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1Zm0 4h6c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1Zm2 6H9c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1Zm4-10h4.4L14 2.6V7c0 .6.4 1 1 1Zm7.7 8.3c-.4-.4-1-.4-1.4 0L18 19.6l-1.3-1.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.4.4 1 .4 1.4 0l4-4c.4-.4.4-1 0-1.4Z"/>
  </SvgIcon>
}

export default SolidFileCheckAltIcon
